export default __webpack_public_path__ + "static/media/LOGO_5.f1c343c7.svg";